import { editAdmin, getAdminGroupList, getAdminList } from '@/services/user/UserController';
import { ActionType } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { debounce } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';

export default () => {
  const [loading, setLoading] = useState(false);
  const actionRef = useRef<ActionType>();

  // 获取用户列表
  const fetchAdminList = useRequest(getAdminList, {
    manual: true,
  });
  // 更新用户列表
  const updateAdmin = useRequest(editAdmin, {
    manual: true,
  });
  // 获取用户组列表
  const fetchAdminGroupList = useRequest(getAdminGroupList, {
    manual: true,
  });

  /**
   *  需要监听Loading状态的方法
   *  仅 useRequest 返回的函数可以录入
   */
  const effectLoadingList = [fetchAdminList, updateAdmin, fetchAdminGroupList];

  /**
   * 监听处理loading状态
   */
  useEffect(() => {
    // 防抖处理的函数，延迟500ms后执行setLoading
    const debouncedSetLoading = debounce((loading: boolean) => {
      setLoading(loading);
    }, 0);
    const bool = effectLoadingList.some((item) => {
      return item.loading;
    });
    debouncedSetLoading(bool);
    // 清理防抖函数
    return () => {
      debouncedSetLoading.cancel();
    };
  }, [fetchAdminList, updateAdmin, fetchAdminGroupList]);

  return { fetchAdminList, updateAdmin, fetchAdminGroupList, actionRef, loading, setLoading };
};
